import { ReleaseNoteCategory } from "@/openapi/generated";

export { CATEGORY_ICONS } from "@donista/shared/utils/release-notes";

export const DEFAULT_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

export const SORT_OPTIONS = [
  { value: "publishedAt", label: "Datum", direction: "desc" },
  { value: "importance", label: "Wichtigkeit", direction: "desc" },
  { value: "title", label: "Titel", direction: "asc" },
  { value: "category", label: "Kategorie", direction: "asc" },
] as const;

export const IMPORTANCE_RANGE = {
  min: 1,
  max: 5,
  default: [1, 5] as const,
} as const;

export const CATEGORY_COLORS: Record<ReleaseNoteCategory, string> = {
  [ReleaseNoteCategory.FEATURE]: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
  [ReleaseNoteCategory.IMPROVEMENT]: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
  [ReleaseNoteCategory.BUGFIX]: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
  [ReleaseNoteCategory.BREAKING_CHANGE]: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200",
};


export const CARD_TEXT_LIMITS = {
  title: 60,
  summary: 150,
} as const;

export const BREAKPOINTS = {
  mobile: 640,
  tablet: 1024,
  desktop: 1280,
} as const;